import { render, staticRenderFns } from "./MemoList.vue?vue&type=template&id=387679e6&scoped=true"
import script from "./MemoList.vue?vue&type=script&lang=ts"
export * from "./MemoList.vue?vue&type=script&lang=ts"
import style0 from "./MemoList.vue?vue&type=style&index=0&id=387679e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387679e6",
  null
  
)

export default component.exports